import { v4 as uuidv4 } from 'uuid';


export function StorageLogout(clear) {

    const deviceUuid = localStorage.getItem('@FPontos:uuid');

    if (deviceUuid == undefined) {
        deviceUuid = uuidv4();
        localStorage.setItem('@FPontos:uuid', deviceUuid) 
    }

    if (clear) {
        localStorage.clear();
        localStorage.setItem('@FPontos:uuid', deviceUuid)
    }
    else {
        localStorage.removeItem("@FPontos:token");
        localStorage.removeItem("@FPontos:user");
        localStorage.removeItem("@FPontos:dataUser");
    }
}

const projeto = process.env.REACT_APP_PROJETO;

export function StorageGetItem(chave) {
    chave = `${projeto}:${chave}`;
    const valor = localStorage.getItem(chave);
    if (valor == undefined)
        return undefined;

    try {
        const obj = JSON.parse(valor);
        if (obj.exp == undefined)
            return obj;

        const milliseconds = new Date().getTime();
        const seconds = Math.floor(milliseconds / 1000);

        if (obj.exp < seconds)
            return undefined;

        return obj.data;

    } catch (error) {
        console.log('StorageGetItem error:', error);
        return undefined;
    }
}

export function StorageSetItem(chave, item, exp) {
    chave = `${projeto}:${chave}`;
    const milliseconds = new Date().getTime();
    const seconds = Math.floor(milliseconds / 1000);
    exp = exp ?? 20 * 60; // 20 minutos
    
    exp = exp + seconds;
    item = {exp: exp , data: item};

    localStorage.setItem(chave, JSON.stringify(item));
}